// @ts-nocheck
import React, { FC, useState } from 'react'
import { useGetDetailUnitMutation } from '@/modules/maps/services/homeMapService'
import { TLineUnit } from '@/modules/maps/types/unitsMapType'
import {
  balloonRed,
  balloonYellow,
  lineGreen,
} from '@/modules/maps/utils/balloons'
import { useMediaQuery } from '@mui/material'
import { Polyline, Placemark } from '@pbe/react-yandex-maps'
import { getLineColor } from '@/components/Organisms/Map/MapLightnings'

interface Props {
  unit: TLineUnit
}

const MyPolyLine: FC<Props> = ({ unit }) => {
  const isMobile = useMediaQuery('(max-width:767px)')
  const [getDetailUnit, { isLoading, isError }] = useGetDetailUnitMutation()
  const [isHovered, setIsHovered] = useState(false)
  // @ts-ignore
  const [unitData, setUnitData] = useState<TLineUnit>({
    id: 0,
    name: '',
    address: '',
    coordinates: '',
  })

  const onLoadData = async (id: number) => {
    try {
      const res = await getDetailUnit(id).unwrap()
      if (Object.values(res).length > 0) {
        // @ts-ignore
        setUnitData(() => res)
      }
    } catch (e) {
      console.log(e)
    }
  }

  if (!unit.coordinates) return null

  // Получаем первую и последнюю точки линии
  const firstPoint = unit.coordinates[0]
  const lastPoint = unit.coordinates[unit.coordinates.length - 1]
  const lineColor = getLineColor(unit?.lightingTypeId)

  return (
    <>
      <Polyline
        geometry={unit.coordinates}
        onClick={() => {
          onLoadData(unit.id)
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        options={{
          strokeColor: lineColor,
          strokeWidth: 4,
          strokeOpacity: isHovered ? 1 : 0.7,
        }}
        properties={{
          balloonContentBody:
            unit.state === 1
              ? lineGreen(isError, isLoading, unitData)
              : unit.state === 2
                ? balloonYellow(isError, isLoading, unitData)
                : balloonRed(isError, isLoading, unitData),
        }}
      />
      {/* Маркер начала линии */}
      <Placemark
        geometry={firstPoint}
        onClick={() => {
          onLoadData(unit.id)
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        properties={{
          balloonContentBody:
            unit.state === 1
              ? lineGreen(isError, isLoading, unitData)
              : unit.state === 2
                ? balloonYellow(isError, isLoading, unitData)
                : balloonRed(isError, isLoading, unitData),
        }}
        options={{
          preset: 'islands#circleDotIcon',
          iconColor: lineColor,
        }}
      />
      {/* Маркер конца линии */}
      <Placemark
        geometry={lastPoint}
        onClick={() => {
          onLoadData(unit.id)
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        properties={{
          balloonContentBody:
            unit.state === 1
              ? lineGreen(isError, isLoading, unitData)
              : unit.state === 2
                ? balloonYellow(isError, isLoading, unitData)
                : balloonRed(isError, isLoading, unitData),
        }}
        options={{
          preset: 'islands#circleDotIcon',
          iconColor: lineColor,
        }}
      />
    </>
  )
}

export default MyPolyLine
